import Vue from 'vue'
import Router from 'vue-router'
import homPage from './views/homPage.vue';
import answerPage from './views/answerPage.vue';
import allIssue from './views/allIssue.vue';
import feedbackPage from "./views/feedbackPage/feedbackPage.vue";
import fucSuggestPage from './views/fucSuggestPage.vue';
import ProjectDetails from './views/ProjectDetails/index.vue';
import HistoryProject from './views/ProjectDetails/HistoryProject.vue';
import userAgreement from './views/privacyPolicy/userAgreement.vue';
import privacyPolicy from "./views/privacyPolicy/privacyPolicy.vue";
import content_serviceHall from "./views/privacyPolicy/content_serviceHall.vue";
import userAgreement_serviceHall from "./views/privacyPolicy/userAgreement_serviceHall.vue";

import searchPage from "./views/searchPage.vue";
import feedbackPageIndex from "./views/feedbackPage/index.vue";
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "homPage",
    },
    {
      path: "/homPage",
      name: "homPage",
      component: homPage,
    },
    {
      path: "/answerPage",
      name: "answerPage",
      component: answerPage,
    },
    {
      path: "/allIssue",
      name: "allIssue",
      component: allIssue,
    },
    {
      path: "/feedbackPage",
      name: "feedbackPage",
      component: feedbackPage,
    },
    {
      path: "/fucSuggestPage",
      name: "fucSuggestPage",
      component: fucSuggestPage,
    },
    {
      path: "/ProjectDetails",
      name: "ProjectDetails",
      component: ProjectDetails,
    },
    {
      path: "/HistoryProject",
      name: "HistoryProject",
      component: HistoryProject,
    },
    {
      path: "/privacyPolicy/userAgreement",
      name: "userAgreement",
      component: userAgreement,
    },
    {
      path: "/privacyPolicy/privacyPolicy",
      name: "privacyPolicy",
      component: privacyPolicy,
    },
    {
      path: "/privacyPolicy/content_serviceHall",
      name: "content_serviceHall",
      component: content_serviceHall,
    },
    {
      path: "/privacyPolicy/userAgreement_serviceHall",
      name: "userAgreement_serviceHall",
      component: userAgreement_serviceHall,
    },
    // 全部问题搜索页
    {
      path: "/searchPage",
      name: "searchPage",
      component: searchPage,
    },
    // 异常反馈记录页
    {
      path: "/feedbackPageIndex",
      name: "feedbackPageIndex",
      component: feedbackPageIndex,
    },
  ],
});